import { markForTranslation as _ } from '@/../../i18n/scripts/utils'
import { passFailState, passFailMutations } from '@/../../troubleshooter/src/store/common/passFail'

const microphoneModule = {
  namespaced: true,
  state: {
    ...passFailState,
    micInstalled: false,
    explainer: [
      _('One of the more common problems is when your browser is not \'allowed\' access to the microphone or camera in your laptop or device.'),
      _('This is essential if you want the other person to see and hear you.'),
      _('Let\'s see if your microphone is working correctly.')
    ],
    title: _('Step 2: Test Your Microphone'),
    nextPage: '#/camera/',
    previousPage: '#/browser/',
    callToAction: {
      'text': _('Test Microphone')
    },
    questionId: 'microphone',
    disabled: false
  },

  mutations: {

    ...passFailMutations,

    isMicInstalled (state) {
      state.micInstalled = true
    },

    disableMic (state) {
      state.disabled = true
    }
  },

  actions: {
  },

  getters: {
  }
}

export default microphoneModule
